/**
 * API Configuration for Taraanaya
 * This file provides centralized API URL configuration that works
 * on both web and native (iOS/Android) platforms.
 */

// PRODUCTION URL - Railway production backend
const PRODUCTION_API_URL = 'https://taraanaya-prod-production.up.railway.app';

// Get the API URL - use env var if available, otherwise use production URL
export const API_URL = process.env.REACT_APP_BACKEND_URL || PRODUCTION_API_URL;

// Log the URL being used (helpful for debugging)
console.log('[ApiConfig] API_URL:', API_URL);

export default API_URL;
